import { createContext } from 'react';
import { TContext } from './PageTitle';
export const PageTitleContext = createContext<TContext | null>(null);